// Fetches Shopify product recommendations via Section Rendering and swaps itself in.
customElements.define(
  "product-recommendations",
  class extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;
      fetch(url)
        .then((r) => r.text())
        .then((text) => {
          const fresh = new DOMParser().parseFromString(text, "text/html").querySelector(".full-width");
          if (fresh) this.replaceWith(fresh);
        })
        .catch(() => { this.hidden = true; });
    }
  }
);
